import { createMachine } from '@monofront/xstate-v4';
import { generateConfig } from './config';
import { generateActions } from './actions';
import { ICustomer, ICustomerAddress } from '@monofront/types';
import { Context, Events, MultiStepFormStep, AddressFormEvent } from './types';

export {
  ACTIONS as MultiStepFormActions,
  MultiStepFormHeaderType,
} from './types';
export type { MultiStepForm, MultiStepFormStep } from './types';

export const createMultiStepFormMachine = ({
  id,
  steps,
  onFormStarted,
  onFormStepSubmitted,
  onFormExited,
  onFormFinished,
  customer,
  checkEligibility,
  addTag,
  removeTag,
  getCollectionPreferences,
  handleAddressForm = () => undefined,
}: {
  id: string;
  steps: Array<MultiStepFormStep>;
  onFormStarted: () => void;
  onFormStepSubmitted: (data: {
    stepNumber: number;
    stepName: string;
    answersSelected: string;
    displayedAnswers: Record<string, string>;
    collectionsToSave: Array<string>;
  }) => void;
  onFormExited: () => void;
  onFormFinished: () => void;
  customer: ICustomer | null;
  checkEligibility: (address: ICustomerAddress) => void;
  addTag: (tag: string) => void;
  removeTag: (tag: string) => void;
  getCollectionPreferences: () => Promise<Array<string>>;
  handleAddressForm?: (address: AddressFormEvent) => void;
}) => {
  const actions = generateActions({
    steps,
    onFormStarted,
    onFormStepSubmitted,
    onFormExited,
    onFormFinished,
    customer,
    checkEligibility,
    addTag,
    removeTag,
  });

  const config = generateConfig({
    id,
    steps,
    customer,
    getCollectionPreferences,
    handleAddressForm,
  });

  return createMachine(
    {
      schema: {
        context: {} as Context,
        events: {} as Events,
      },
      ...config,
      predictableActionArguments: true,
    },
    { actions },
  );
};

export type MultiStepFormMachine = ReturnType<
  typeof createMultiStepFormMachine
>;
export * from './types';
